import React from "react";
import { PERCENTAGE, CURRENCY_EUR } from "./columnFormat";

const TableBody = ({ tableData, columns }) => {
    return (
      <tbody>
        {tableData.map((data) => {
          return (
            <tr key={data.id}>
              {columns.map(({ accessor, format }) => {
                const tData = data[accessor] != null ? data[accessor] : "——";
                let formatted;
                switch(format? format: "STRING") {
                  case CURRENCY_EUR:
                    let EURO = new Intl.NumberFormat('en-EU', {
                      style: 'currency',
                      currency: 'EUR',
                    });
                    formatted = EURO.format(tData);
                    break;
                  case PERCENTAGE:
                    formatted = tData + " %";
                    break;
                  default:
                    formatted = tData;
                    break;
                }
                return <td key={accessor} style={{ width: `calc(100% / ${columns.length})`}}>{formatted}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    );
  };
  
  export default TableBody;